import { create } from "zustand";

type SpotlightContainer =
  | "cask"
  | "keg"
  | "can"
  | "bottle"
  | "bag"
  | "pouch"
  | "bagInBox"
  | "jerryCan"
  | "box";

type SpotlightFilterState = {
  selectedContainerTypes: SpotlightContainer[];
  addContainerType: (type: SpotlightContainer) => void;
  removeContainerType: (type: SpotlightContainer) => void;
  toggleContainerType: (type: SpotlightContainer) => void;
  setContainerTypes: (types: SpotlightContainer[]) => void;
  clearContainerTypes: () => void;
};

export const useSpotlightFilterStore = create<SpotlightFilterState>((set) => ({
  selectedContainerTypes: [],
  addContainerType: (type) =>
    set((state) => ({
      selectedContainerTypes: [...state.selectedContainerTypes, type],
    })),
  removeContainerType: (type) =>
    set((state) => ({
      selectedContainerTypes: state.selectedContainerTypes.filter(
        (t) => t !== type,
      ),
    })),
  toggleContainerType: (type) =>
    set((state) => ({
      selectedContainerTypes: state.selectedContainerTypes.includes(type)
        ? state.selectedContainerTypes.filter((t) => t !== type)
        : [...state.selectedContainerTypes, type],
    })),
  setContainerTypes: (types) => set({ selectedContainerTypes: types }),
  clearContainerTypes: () => set({ selectedContainerTypes: [] }),
}));
